import { CellStyle } from 'ag-grid-community'

const cellStyle: CellStyle = {
  justifyContent: 'flex-end',
}

export default cellStyle
